export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Cyrillic-ddc7a038e2c33116b951963485c726f6.woff2";